import React from 'react';

import TestimonialSmall from './Small';
import TestimonialLarge from './Large';
import TestimonialFull from './Full';

const Testimonial = ({ viewMode, ...props }) => {
  switch (viewMode) {
    case 'small':
      return <TestimonialSmall {...props} />;
    case 'large':
      return <TestimonialLarge {...props} />;
    default:
      return <TestimonialFull {...props} />;
  }
};

export default Testimonial;
